import { jsx as _jsx } from "react/jsx-runtime";
import { CustomButtons, PrimaryAndSecondaryButtons, PrimaryAndThreeDotsButtons, SimpleButton, SimpleDropdownButton, } from './MainActionContent';
import { MAIN_ACTIONS_TYPE } from '../constants';
import { usePageHeaderContext } from '../context/PageHeaderContext';
export const MainActionType = () => {
    const { mainAction } = usePageHeaderContext();
    if (!mainAction.type || !mainAction.content) {
        return null;
    }
    const { content: mainActionContent, type: mainActionType } = mainAction;
    switch (mainActionType) {
        case MAIN_ACTIONS_TYPE.SIMPLE_DROPDOWN_BUTTON:
            return _jsx(SimpleDropdownButton, Object.assign({}, mainActionContent));
        case MAIN_ACTIONS_TYPE.PRIMARY_AND_SECONDARY_BUTTONS:
            return _jsx(PrimaryAndSecondaryButtons, Object.assign({}, mainActionContent));
        case MAIN_ACTIONS_TYPE.PRIMARY_AND_THREE_DOTS_BUTTONS:
            return _jsx(PrimaryAndThreeDotsButtons, Object.assign({}, mainActionContent));
        case MAIN_ACTIONS_TYPE.CUSTOM_BUTTONS:
            return _jsx(CustomButtons, Object.assign({}, mainActionContent));
        case MAIN_ACTIONS_TYPE.SIMPLE_BUTTON:
        default:
            return _jsx(SimpleButton, Object.assign({}, mainActionContent));
    }
};
//# sourceMappingURL=MainActionType.js.map